import moment from 'moment';

/**
 Helper file for formatting the date when displaying the time for the MyComment and NotMyComment component
 */
export const handleDate = (timestamp) => moment(timestamp).format('MMM D, YYYY [at] h:mm A z');
